import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _DellFill(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0m-9 1.414-3.293 3.293-1.414-1.414L10.586 12 7.293 8.707l1.414-1.414L12 10.586l3.293-3.293 1.414 1.414L13.414 12l3.293 3.293-1.414 1.414z", clipRule: "evenodd" }) }) });
}
const DellFill = forwardRef(_DellFill);
export { DellFill };
